import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { cloneDeep } from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class ObjectToolService {

    constructor() { }

    //Find the first object that contains the given field value f
    findInObject(dataObject, field, _cloneDeep = false) {
        if (dataObject === undefined || field === undefined) {
            return;
        }

        let found;
        for (let i = 0; i < Object.keys(dataObject).length; i++) {
            if (dataObject[Object.keys(dataObject)[i]] === field) {
                if (_cloneDeep) {
                    return cloneDeep(dataObject);
                }
                else {
                    return dataObject;
                }
            }
            if (Array.isArray(dataObject[Object.keys(dataObject)[i]]) || typeof dataObject[Object.keys(dataObject)[i]] === 'object' && dataObject[Object.keys(dataObject)[i]] !== null) {
                found = this.findInObject(dataObject[Object.keys(dataObject)[i]], field, true);
                if (found) {
                    if (_cloneDeep) {
                        return cloneDeep(found);
                    }
                    else {
                        return found;
                    }
                }
            }
        }
    }

    //Find all objects that has the property f
    findAllPropertiesInObject(o, p) {
        const arr = [];
        function startMapping(o, p) {
            const keys = Object.keys(o);
            let temp;
            for (let i = 0; i < keys.length; i++) {
                if (keys[i] === p) {
                    arr.push(o);
                }
                if (Array.isArray(o[keys[i]]) || typeof o[keys[i]] === 'object' && o[keys[i]] !== null) {
                    temp = startMapping(o[keys[i]], p);
                    if (temp) {
                        arr.push(temp);
                    }
                }
            }
        }
        startMapping(o, p);
        return arr;
    }

    //Find object based on fieldValue and removes from the object
    findInObjectAndRemove(object, fieldValue, outerObject?) {
        let found;
        for (let i = 0; i < Object.keys(object).length; i++) {
            if (object[Object.keys(object)[i]] === fieldValue) {
                outerObject.splice(outerObject.indexOf(object), 1);
            }
            if (Array.isArray(object[Object.keys(object)[i]]) || typeof object[Object.keys(object)[i]] === 'object' && object[Object.keys(object)[i]] !== null) {
                found = this.findInObjectAndRemove(object[Object.keys(object)[i]], fieldValue, object);
                if (found) {
                    outerObject.splice(outerObject.indexOf(object), 1);
                }
            }
        }
    }

    getFormErrors(form: AbstractControl, formName = 'Sections') {
        const errors = [];
        function getErrors(form: AbstractControl, formName = 'Sections') {
            if (form instanceof UntypedFormControl) {
                // Return FormControl errors or null
                return form.errors ?? null;
            }
            if (form instanceof UntypedFormGroup || form instanceof UntypedFormArray) {
                const groupErrors = form.errors;
                Object.keys(form.controls).forEach(key => {
                    // Recursive call of the FormGroup fields
                    const error = getErrors(form.get(key), key);
                    if (error !== null) {
                        Object.keys(error).forEach(l => {
                            // Only add error if not null
                            errors.push(errorType(key, error[l], l));
                        });
                    }
                });
                // Return FormGroup errors or null
                return groupErrors ? groupErrors : null;
            }

            function errorType(key, error, errorName) {
                switch (key) {
                    case 'SectionTitle': key = 'Section Title';
                    case 'enum': key = 'Combobox options';
                }
                switch (errorName) {
                    case 'required': return `${key} is required!`; case 'pattern': return `${key} has wrong pattern!`; case 'email': return `${key} has wrong email format!`; case 'minlength': return `${key} has wrong length! Required length: ${error.requiredLength}`; case 'areEqual': return `${key} must be equal!`; default: return `${key}: ${errorName}: ${error}`;
                }
            }
        }
        getErrors(form);
        return errors;
    }

}
